import axios from "axios";
import { format } from "date-fns";

import { TIIVII_GET_RECORDINGS_ENDPOINT } from "../utils/constants";
import { buildQueryParams, buildUrl, getOptions } from "./commonService";
import { LARGE_SELECT_LIMIT } from "../components/select/utils/select-constants";
import { apiPaginationConverter } from "../utils/api-pagination";

export const getRecordingsService = (variables, callback, errorCallback) => {
  const config = getOptions({});
  let url = buildUrl(TIIVII_GET_RECORDINGS_ENDPOINT, {});

  const { eventId, page, perPage, limit, visible, startDate, endDate, deploymentId } = variables;

  const queryParams = buildQueryParams({
    limit: Number.isInteger(page) ? perPage : limit ?? LARGE_SELECT_LIMIT,
    offset: Number.isInteger(page) ? apiPaginationConverter(page, perPage).offset : undefined,
    event_id: eventId ?? undefined,
    deployment_ids: !!deploymentId ? [deploymentId] : undefined,
    visible: visible !== undefined ? !!visible : undefined,
    from: startDate ? format(new Date(startDate), "t") : undefined,
    to: endDate ? format(new Date(endDate), "t") : undefined,
  });

  url = `${url}?${queryParams}`;

  axios
    .get(url, config)
    .then(response => {
      callback(response);
    })
    .catch(e => {
      errorCallback(e);
    });
};
